import React from "react";
import ReactDOM from "react-dom/client"; // Altere aqui
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

// Use createRoot em vez de render
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
